import { render, staticRenderFns } from "./NewPostMobile.vue?vue&type=template&id=2a73dfc8&scoped=true"
import script from "./NewPostMobile.vue?vue&type=script&lang=js"
export * from "./NewPostMobile.vue?vue&type=script&lang=js"
import style0 from "./NewPostMobile.vue?vue&type=style&index=0&id=2a73dfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73dfc8",
  null
  
)

export default component.exports